import { SEARCH_SAVE } from './actionTypes'

/* TODO: Refactor */

/**
 * API request to save the user defined search.
 * @param {string} name
 * @param {object} params
 * @param {array} currentResults
 * @param {number} rugs
 * @param {number} user
 */
export const saveSearch = (name, params, currentResults, rugs, user) => ({
  meta: {
    data: { currentResults, name, params, rugs, user },
    method: 'post',
    url: '/api/v1/search/add',
  },
  type: SEARCH_SAVE,
})
